import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\StoreWebsiteFormSubmissionController::__invoke
* @see app/Http/Controllers/StoreWebsiteFormSubmissionController.php:14
* @route '/__proexpert/forms/{form}/submissions'
*/
const StoreWebsiteFormSubmissionController = (args: { form: string | { id: string } } | [form: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StoreWebsiteFormSubmissionController.url(args, options),
    method: 'post',
})

StoreWebsiteFormSubmissionController.definition = {
    methods: ["post"],
    url: '/__proexpert/forms/{form}/submissions',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\StoreWebsiteFormSubmissionController::__invoke
* @see app/Http/Controllers/StoreWebsiteFormSubmissionController.php:14
* @route '/__proexpert/forms/{form}/submissions'
*/
StoreWebsiteFormSubmissionController.url = (args: { form: string | { id: string } } | [form: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { form: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { form: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            form: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        form: typeof args.form === 'object'
        ? args.form.id
        : args.form,
    }

    return StoreWebsiteFormSubmissionController.definition.url
            .replace('{form}', parsedArgs.form.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\StoreWebsiteFormSubmissionController::__invoke
* @see app/Http/Controllers/StoreWebsiteFormSubmissionController.php:14
* @route '/__proexpert/forms/{form}/submissions'
*/
StoreWebsiteFormSubmissionController.post = (args: { form: string | { id: string } } | [form: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StoreWebsiteFormSubmissionController.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\StoreWebsiteFormSubmissionController::__invoke
* @see app/Http/Controllers/StoreWebsiteFormSubmissionController.php:14
* @route '/__proexpert/forms/{form}/submissions'
*/
const StoreWebsiteFormSubmissionControllerForm = (args: { form: string | { id: string } } | [form: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: StoreWebsiteFormSubmissionController.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\StoreWebsiteFormSubmissionController::__invoke
* @see app/Http/Controllers/StoreWebsiteFormSubmissionController.php:14
* @route '/__proexpert/forms/{form}/submissions'
*/
StoreWebsiteFormSubmissionControllerForm.post = (args: { form: string | { id: string } } | [form: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: StoreWebsiteFormSubmissionController.url(args, options),
    method: 'post',
})

StoreWebsiteFormSubmissionController.form = StoreWebsiteFormSubmissionControllerForm

export default StoreWebsiteFormSubmissionController